import FlowEdge from './FlowEdge';
import QuestDependencyEdge from './QuestDependencyEdge';
import MissionDependencyEdge from './MissionDependencyEdge';
import MissionQuestEdge from './MissionQuestEdge';
import QuestMissionTransitionEdge from './QuestMissionTransitionEdge';

export const edgeTypes = {
  flowEdge: FlowEdge,
  questDependencyEdge: QuestDependencyEdge,
  missionDependencyEdge: MissionDependencyEdge,
  missionQuestEdge: MissionQuestEdge,
  questMissionTransitionEdge: QuestMissionTransitionEdge
};
